'use strict';

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import {ExclamationTriangleFill} from "react-bootstrap-icons";

import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

import {isFalse} from "@uw-it-sis/lib-react/lib/Utils";
import HelpPopover from "@uw-it-sis/lib-react/lib/HelpPopover";

import {ProtocolLabels} from "./utils/Constants";
import {phoneFormat} from "./utils/Utils";
import ProfileStore from "./ProfileStore";

const EndpointCheckbox = ({endpoint, termId, activityCode = "new", disabled = false, checked = false, onChange = () => {}}) => {
    let smsMessage, emailMessage;
    let isDisabled = disabled;
    const isChecked = checked;
    const warningId = `${endpoint.Protocol}-warning-${termId}-${activityCode}`;

    if ( endpoint.hasOwnProperty("Active") && isFalse(endpoint.Active) ) {
        isDisabled = true;
        smsMessage =
            <div className="fade d-flex align-items-start mt-2 mb-0 p-2 gap-2 alert alert-warning show" id={warningId}>
                <span className="lh-1"><ExclamationTriangleFill aria-hidden={true} className="fs-6" /></span>
                <small>{ProtocolLabels[endpoint.Protocol].text} confirmation is pending. Reply to the confirmation text sent to your mobile phone. <Button variant="inline-link" onClick={ProfileStore.resendSmsVerification}>Resend the confirmation</Button></small>
            </div>
    }

    if ( endpoint.Protocol === "email" && ProfileStore.isEmailEndpointBlocked() ) {
        isDisabled = true;
        // <Button variant="inline-link" onClick={ProfileStore.unblockEmail}>Unblock {ProtocolLabels[endpoint.Protocol].text}</Button>
        emailMessage =
            <>
                <div className="fade d-inline-block py-0 px-2 alert alert-danger show mb-0" id={warningId}>
                    <small className="text-uppercase fw-bold">Blocked</small>{" "}
                    <span className="sr-only">Email Address. You must unblock your address in the contact methods to use this notification type.</span>
                </div>
                <HelpPopover title="Your Email Address Is Blocked" className="fs-5 p-1" placement="top">
                    <p>You have blocked your email address, so it cannot receive any notifications from Notify.UW.</p>
                    <p>To unblock this address or to subscribe to notifications with a different email address, click
                        the "Edit Contact Methods" button in the "Your Contact Methods" section.</p>
                </HelpPopover>
            </>
    }

    let address = endpoint.EndpointAddress;
    if (endpoint.Protocol === 'sms') {
        address = phoneFormat(endpoint.EndpointAddress);
    }

    return (
        <>
            <div className="d-flex align-items-center gap-2">
                <Form.Check id={`option-${endpoint.Protocol}-${termId}-${activityCode}`}
                            type="checkbox"
                            className="mb-0">
                    <Form.Check.Input
                        name={endpoint.Protocol}
                        type="checkbox"
                        checked={isChecked}
                        onChange={onChange}
                        disabled={isDisabled}
                    />
                    <Form.Check.Label className="d-inline-flex align-items-center gap-2">
                        <span className="fw-bold">{ProtocolLabels[endpoint.Protocol].text}</span>
                        <small className="text-muted form-text mt-0">{address}</small>
                    </Form.Check.Label>
                </Form.Check>
                {emailMessage}
            </div>
            {smsMessage}
        </>
    )
}

EndpointCheckbox.propTypes = {
    termId: PropTypes.string.isRequired,
    activityCode: PropTypes.string,
    endpoint: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool
}

export default EndpointCheckbox;
